/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoHouseSubtype = typeof ListingDetailResponseDtoHouseSubtype[keyof typeof ListingDetailResponseDtoHouseSubtype] | null;


export const ListingDetailResponseDtoHouseSubtype = {
  FAMILY_HOUSE: 'FAMILY_HOUSE',
  VILLA: 'VILLA',
  LOG_HOUSE: 'LOG_HOUSE',
  BUNGALOW: 'BUNGALOW',
  COUNTRY_HOUSE: 'COUNTRY_HOUSE',
  MOBILE_HOUSE: 'MOBILE_HOUSE',
  HOUSEBOAT: 'HOUSEBOAT',
} as const;
